import { ProcessedCallActions } from "./action";

export default function reduceProcessedCalls(state, action) {
  switch (action.type) {
    case ProcessedCallActions.SET_STATE:
      return {
        ...state,
        queuedAtTimestamp: action.payload.queuedAt,
        pendingCalls: action.payload.pendingCalls,
        failedCalls: action.payload.failedCalls,
        completedCalls: action.payload.completedCalls,
        totalCalls: action.payload.completedCalls + action.payload.failedCalls,
        concurrencyLimit: action.payload.concurrencyLimit,
        concurrentCalls: action.payload.concurrentCalls,
        lastUpdatedAt: Date.now(),
        isLoading: false,
      };
    case ProcessedCallActions.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case ProcessedCallActions.UPDATE_QUEUED_AT:
      return {
        ...state,
        queuedAt: action.payload.queuedAt,
        queuedAtTimestamp: action.payload.queuedAtTimestamp,
      };
    default:
      return state;
  }
}
